module.exports = __webpack_public_path__ + "img/img_sc_3.e14a80f9.webp";